import React from 'react';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import { FormikProps } from 'formik';
import { ShopFormValues } from 'components/Types/Tenant/shop.type';

interface Props {
  formik: FormikProps<ShopFormValues>;
}

const SeoSettingsTab: React.FC<Props> = ({ formik }) => {
  return (
    <Row>
      <Col md={6}>
        <FormGroup>
          <Label>Meta Description</Label>
          <Input
            type="textarea"
            name="metaDescription"
            value={formik.values.metaDescription}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.metaDescription && formik.errors.metaDescription)}
          />
          {formik.touched.metaDescription && formik.errors.metaDescription && (
            <div className="invalid-feedback">{formik.errors.metaDescription}</div>
          )}
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label>Meta Keywords</Label>
          <Input
            type="text"
            name="metaKeywords"
            value={formik.values.metaKeywords}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.metaKeywords && formik.errors.metaKeywords)}
          />
          {formik.touched.metaKeywords && formik.errors.metaKeywords && (
            <div className="invalid-feedback">{formik.errors.metaKeywords}</div>
          )}
        </FormGroup>
      </Col>
    </Row>
  );
};

export default SeoSettingsTab;
